<template>
	<header class="headerWrap">
		<div class="content">
			<div class="siteLogo">
				<img :src="system.logo" alt="" />
				<span>{{ system.name }}旗下<br>官方购票平台</span>
			</div>
			<div class="navWrap">
				<div class="loginWrap">
					<span class="tel">游客服务热线：<i>{{ system.telephone }}</i></span>
					<div class="login">
						<template v-if="token">
							<img :src="avatar" class="avatar" />
							<span>{{ phone }}</span>
							<div class="flex-row flex-xy-center dropdown">
								<div class="flex-row flex-xy-center">
									<span>个人中心</span>
									<img src="~@/assets/images/arrow.png" alt="" />
								</div>
								<div class="list flex-col flex-xy-center">
									<router-link class="item" :to="{ path: '/tourist/index' }">我的订单</router-link>
									<router-link class="item" :to="{ path: '/tourist/coupon' }">我的优惠券</router-link>
									<router-link class="item" :to="{ path: '/tourist/info' }">个人中心</router-link>
								</div>
							</div>
							<router-link :to="{ path: '/auth/login' }">退出</router-link>
						</template>
						<template v-else>
							<span><router-link :to="{ path: '/auth/register' }">注册</router-link></span>
							<span><router-link :to="{ path: '/auth/login' }">登录</router-link></span>
						</template>
					</div>
				</div>
				<form class="search" :action="`${system.domain}/search.html`" method="get">
					<select name="model" class="searchType" v-model="model">
						<option value="">所有产品</option>
						<option value="ticket">景区门票</option>
						<option value="hotel">度假酒店</option>
						<option value="package">度假套餐</option>
						<option value="store">风物文创</option>
					</select>
					<input type="text" class="searchInput" name="keyword" v-model="keyword" />
					<img class="searchIcon" src="~@/assets/images/u96.svg" alt="" @click="handleSearch">
				</form>
				<div class="tab">
					<div class="tab-item"><a :href="`${system.domain}`">首页</a></div>
					<div class="tab-item"><a :href="`${system.domain}/ticket.html`">景区门票</a></div>
					<div class="tab-item"><a :href="`${system.domain}/package.html`">度假套餐</a></div>
					<div class="tab-item"><a :href="`${system.domain}/hotel.html`">度假酒店</a></div>
					<div class="tab-item"><a :href="`${system.domain}/store.html`">风物文创</a></div>
					<div class="tab-item"><a :href="`${system.domain}/map.html`">小镇地图</a></div>
					<div class="tab-item"><a :href="`${system.domain}/activity.html`">促销活动</a></div>
					<div class="tab-item"><a :href="`${system.domain}/service/25.html`">游客服务</a></div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import { getSystemConfig } from '@/api/common'
import { mapGetters } from 'vuex'
export default {
	name: 'Header',
	components: {

	},
	computed: {
		...mapGetters(['token', 'phone', 'avatar'])
	},
	data() {
		return {
			system: {},
			model: '',
			keyword: ''
		}
	},
	created() {
		this.getSystemConfig()
	},
	methods: {
		getSystemConfig() {
			getSystemConfig({}).then(res => {
				this.system = res.data
			})
		},
		handleSearch() {
			location.href = `${this.system.domain}/search.html?model=${this.model}&keyword=${this.keyword}`
		}
	}

}
</script>

<style lang="scss" scoped></style>
